"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGroupedCalendarEvents = exports.groupEventsBySport = exports.useGroupedTournamentsBySport = exports.groupTournamentsBySport = exports.useGroupedEventsByGroupId = void 0;
exports.useGroupedEvents = useGroupedEvents;
exports.useGroupedTournaments = useGroupedTournaments;
exports.useProbs = useProbs;
const react_1 = require("react");
const groupTournamentsBySport_1 = require("../../utils/tournaments/groupTournamentsBySport");
const groupEventGroupsBySport_1 = require("../../utils/events/groupEventGroupsBySport");
const groupBySport_1 = require("../../utils/events/groupBySport");
const groupAllEventsBySameTournament_1 = require("../../utils/events/groupAllEventsBySameTournament");
const groupAllEventsByGroupId_1 = require("../../utils/events/groupAllEventsByGroupId");
const groupCalendarEvents_1 = require("../../utils/events/groupCalendarEvents");
const _groupProbsByOutcomeIds_1 = require("../../utils/events/probabilities/_groupProbsByOutcomeIds");
/**
 * !!! Hook does NOT guarantee order of events
 *
 * Create event groups, grouped by tournaments
 * @param events Event[]
 * @returns EventsGroup[]
 */
function useGroupedEvents(events) {
    return (0, react_1.useMemo)(() => {
        return (0, groupAllEventsBySameTournament_1.groupAllEventBySameTournament)(events);
    }, [events]);
}
/**
 * !!! Hook does NOT guarantee order of events
 *
 * Create event groups, grouped by tournaments and groupId
 * @param events Event[]
 * @returns EventsGroup[]
 */
const useGroupedEventsByGroupId = (events) => {
    return (0, react_1.useMemo)(() => {
        return (0, groupAllEventsByGroupId_1.groupAllEventsByGroupId)(events);
    }, [events]);
};
exports.useGroupedEventsByGroupId = useGroupedEventsByGroupId;
exports.groupTournamentsBySport = groupEventGroupsBySport_1.groupEventGroupsBySport;
/**
 * Hook does NOT guarantee order of events
 * Group EventGroups by sport
 * @param events Event[]
 * @returns SportTournamentsGroup[]
 */
const useGroupedTournamentsBySport = (events) => {
    return (0, react_1.useMemo)(() => {
        return (0, groupEventGroupsBySport_1.groupEventGroupsBySport)(events);
    }, [events]);
};
exports.useGroupedTournamentsBySport = useGroupedTournamentsBySport;
/**
 * Group Events by sport and map to SportEventsGroup with saved order
 * @param events Event[]
 * @returns SportEventsGroup[]
 */
exports.groupEventsBySport = groupBySport_1.groupEventsBySport;
// TODO: used in v1 calendar on OG desktop, save until fully moved to v2
/**
 * Hook does NOT guarantee order of events
 *
 * @deprecated Use api v2 without client sorting/ordering
 * @param events
 * @returns
 */
const useGroupedCalendarEvents = (events) => {
    return (0, react_1.useMemo)(() => {
        return (0, groupCalendarEvents_1.groupCalendarEvents)(events);
    }, [events]);
};
exports.useGroupedCalendarEvents = useGroupedCalendarEvents;
/**
 * Group Tournaments by sport
 * @param events Event[]
 * @returns TournamentsGroup[]
 */
function useGroupedTournaments(tournaments, sports) {
    return (0, react_1.useMemo)(() => (0, groupTournamentsBySport_1.groupTournamentsBySport)(tournaments, sports), [tournaments, sports]);
}
/**
 * Helper function for grouping event probabilities by theit outcome id
 * Additionally base on clientFilteredProbsMap funtion finds correct pairs for TOTAL | HANDICAP
 * @param event Event
 * @param clientFilteredProbsMap ClientFilteredProbsMapWithOutcomeIds
 * @returns Record<OutcomeType['id'], EventProbability>
 */
function useProbs(event, clientFilteredProbsMap) {
    return (0, react_1.useMemo)(() => {
        return (0, _groupProbsByOutcomeIds_1._groupProbsByOutcomeIds)(event, clientFilteredProbsMap);
    }, [event, clientFilteredProbsMap]);
}
//# sourceMappingURL=index.js.map